export default __webpack_public_path__ + "static/goethe-dfcfea935da6990ee084fcc3447483a1.png";